import { render, staticRenderFns } from "./FaqLayout.vue?vue&type=template&id=a697b290&scoped=true&"
import script from "./FaqLayout.vue?vue&type=script&lang=js&"
export * from "./FaqLayout.vue?vue&type=script&lang=js&"
import style0 from "./FaqLayout.vue?vue&type=style&index=0&id=a697b290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a697b290",
  null
  
)

export default component.exports